import { createSelector } from "reselect";
import { dataSelector } from "src/selectors/data_selectors/data_selector";

export const populationPrevalenceChartDataSelector = createSelector(
  dataSelector,
  data => data.populationPrevalenceChartData
);
